module.exports = __webpack_public_path__ + "img/REP-alt.c36a1bcb.svg";